export function getMaxCellsMinHeight(
  cellMinimumHeights: Record<string, number>,
) {
  const cellMinHeights = [...Object.values(cellMinimumHeights ?? {})];

  return Math.max(...cellMinHeights);
}
